import axios from "axios";
import humps from "humps";
// @ts-expect-error
import localStorage from "localStorage";
import { isMobile } from "mobile-device-detect";

const ISO_DATE_KEY = /^\d{4}-\d{2}-\d{2}$/;

export const camelizeResponseKeys = (data: object) =>
  humps.camelizeKeys(data, (key, convert) =>
    ISO_DATE_KEY.test(key) ? key : convert(key)
  );

const loadUserData = async () => {
  const authDataSerialized = await localStorage.getItem("@AuthData");
  if (authDataSerialized) {
    const _authData = JSON.parse(authDataSerialized);
    return _authData;
  }
  return null;
};

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.interceptors.request.use(
  async (request) => {
    if (
      request.method === "post" ||
      request.method === "POST" ||
      request.method === "put" ||
      request.method === "PUT" ||
      request.method === "patch" ||
      request.method === "PATCH"
    ) {
      if (request.headers?.["Content-Type"] !== "multipart/form-data") {
        request.data = humps.decamelizeKeys(request.data);
      }
    }

    request.headers = request.headers ?? {};
    request.headers["X-Device-Type"] = isMobile ? "mobile" : "web";
    request.headers["X-Redwing-Paywall-Version"] = "3";

    const userData = await loadUserData();
    if (userData) {
      request.headers.Authorization = `Bearer ${userData.token}`;
    }

    return request;
  },
  (error) => Promise.reject(error)
);

/**
 * Intercept response
 *
 * - Camelize keys of data received from backend
 */
axios.interceptors.response.use(
  (response) => {
    if (
      (response.headers["content-type"] &&
        response.headers["content-type"].match(/application\/json/g)) ||
      (response.headers["Content-Type"] &&
        response.headers["Content-Type"].match(/application\/json/g))
    ) {
      response.data = camelizeResponseKeys(response.data);
    }

    if (!response.data) {
      response.data = [];
    }

    return response;
  },
  (error) => {
    if (error.response) {
      console.log("Error ", error);
      if (error.response.status === 401) {
        console.log("You are unauthenticated");
        localStorage.removeItem("@AuthData");
        window.location.href = "/login";
      }

      if (error.response.status === 404) {
        window.location.href = "/404";
      }

      if (
        error.response.status === 503 &&
        window.location.pathname !== "/maintenance"
      ) {
        window.location.href = "/maintenance";
      }
    }

    return Promise.reject(error);
  }
);

export default axios;
